<template>
  <li>
    <h4 :title="trackingGroup.name">
      <span>{{ trackingGroup.abbreviation || trackingGroup.name }}</span>
    </h4>
    <span
      v-for="measurementType in trackingGroup.MeasurementTypes"
      class="values">
      <template v-if="measurementType.input_type === 'complex'">
        <template v-for="item in measurementType.MeasurementTypeOptions">
          <span class="measurement-value" :title="_get(item, 'name')">{{ _get(item, 'name') | first-string }} {{ _get(measurementType, `Measurement.value_json.${item.code}`, 0) | number-format(2) }}</span>
          <span class="measurement-unit">{{ measurementType.expressed_in_unit }} </span>
        </template>
      </template>
      <template v-else>
        <span
           v-if="measurementType.display === 'level'"
           class="measurement-value"
          :title="measurementType.name">
          {{ measurementType.MeasurementTypeOptions[measurementType.Measurement.value_text].name }}
        </span>
        <span v-else class="measurement-value">
          {{ measurementType.Measurement.value | number-format(2) }}
        </span>
        <span class="measurement-unit">
          {{ measurementType.expressed_in_unit }}
        </span>
      </template>
    </span>
  </li>
</template>

<script>
import LabelGroupAbstract from './label-group-abstract';

export default {
  mixins: [LabelGroupAbstract],
  name: 'tracked-measurements-label-group-value-level',
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/tracked-measurements-label-groups/label-group-value-level.vue